<template>
  <div class="chart-data-empty">
    <img style="display: inline-block" src="../assets/no-message.png" width="120px" />
    <div class="tip">暂无数据</div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus">
.chart-data-empty
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction column
  background-color: rgba(255, 255, 255, 1);
  color: #888;
  font-size: 14px;
.tip
  text-align center
</style>
